import React, { useEffect, useState } from "react";
import { Workflow } from "lucide-react";
import { Button } from "../../components/Button";
import { CreateWorkflowModal } from "../Workflow/CreateWorkflowModal";
import { useSelector } from "react-redux";
import workflowApi from "../../api/workflowApi";
import { toast } from "react-toastify";
import { getPriorityColor, getStatusColor } from "../../utils/colors";
import WorkflowTasksTabAll from "../../components/workflow/WorkflowTabAll";
import { confirmSubmit } from "../../utils/confirmSubmit";

const WorkflowsTab = ({ selectedClientData, onRefreshAccounts}) => {
  const [showCreateTask, setShowCreateTask] = useState(false);
       const [isLoader, setIsLoader] = useState(false);
           const [workflowId, setWorkflowId] = useState(null);
 const userId = useSelector((state) => state.auth.userdetails.id);
    const token = useSelector((state) => state.auth.access_token);
    const [loading, setLoading] = useState(false);
        const [workflows, setWorkflows] = useState([]);

            const [formData, setFormData] = useState({
                name: "",
                description:"",
                status:"TODO",
                category:"",
                template:"",
                account: "",
                assignedTo: "",
                createdBy: "",
                startDate:"",
                dueDate:""
            });
            useEffect(()=> {
                const today = new Date();
                const tomorrow = new Date();
                tomorrow.setDate(today.getDate() + 1);
        
                setFormData(prev => ({
                    ...prev,
                    startDate: today.toISOString().split("T")[0],
                    dueDate: tomorrow.toISOString().split("T")[0],
                    assignedTo: { id: userId },
                    createdBy: { id: userId },
                    account: { id: selectedClientData.id },
                }));
            }, [userId, selectedClientData]);
    
     const fetchWorkflows = async () => {
        try {
            setLoading(true);
            const response = await workflowApi.WorkflowByAccountId(selectedClientData.id, token);
            setWorkflows(response?.data.content || []);
        } catch (error) {
            console.error('Error fetching workflows:', error);
            // toast.error('Failed to load workflows');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchWorkflows();
    }, [token]);

    const [errors, setErrors] = useState({});
      const safeTrim = (value) => (value || "").trim();
    
      const validateForm = () => {
            const newErrors = {};
    
            if (!safeTrim(formData.name))
                newErrors.name = "Name is required";
    
            if (!formData.status)
                newErrors.status = "Status is required";
            // if (!formData.account)
            //     newErrors.account = "Account is required";
            if (!formData.assignedTo)
                newErrors.assignedTo = "Assigned To is required";
            if (!formData.category)
                newErrors.category = "Category is required";
            if (!formData.template)
                newErrors.template = "Template is required";
            if (!formData.startDate)
                newErrors.startDate = "Start Date is required";
            if (!formData.dueDate)
                newErrors.dueDate = "Due Date is required";
            if (!formData.description)
                newErrors.description = "Description is required";
    
            setErrors(newErrors);
            return Object.keys(newErrors).length === 0;
            };
    

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
              toast.error("Please fill all required fields correctly.");
              setIsLoader(false);
              return;
          }
        const payload = {
            name: formData?.name,
            description: formData?.description,
            status: formData?.status,
            category: formData?.category,
            template: formData?.template,
            accountId:selectedClientData.id,
            assignedToId: userId,
            createdBy: { id: userId },
            startDate: formData?.startDate,
            dueDate: formData?.dueDate
        };

        // console.log("Workflow create request payload:", payload);

        try {
            setIsLoader(true);
            if (workflowId) {
                await workflowApi.updateWorkflow(workflowId, payload, token);
                setIsLoader(false);
                toast.success("Workflow update successfully!");
                setShowCreateTask(false);
                fetchWorkflows();
                onRefreshAccounts();
                setFormData({
                    name: "",
                    description:"",
                    status:"TODO",
                    category:"",
                    template:"",
                    account: { id: selectedClientData.id },
                });
                setWorkflowId(null);
            }else{
               await workflowApi.createWorkflow(payload, token);
                setIsLoader(false);
                toast.success("Workflow created successfully!");
                setShowCreateTask(false);
                fetchWorkflows();
                onRefreshAccounts();
                setWorkflowId(null);
                setFormData({
                    name: "",
                    description:"",
                    status:"TODO",
                    category:"",
                    template:"",
                    account: { id: selectedClientData.id },
                });
            }
        } catch (error) {
            console.error("Error creating workflow:", error);
            // toast.error(error);
            setIsLoader(false);
        }
    };

    const handleDeleteWorkflowNew = async (workflowId) => {
            const confirmed = await confirmSubmit({
                              title: "Confirm workflow delete",
                              text: "Are you sure you want to delete this workflow?",
                              confirmText: "Submit",
                            });
            
                    if (!confirmed) return;
            try {
                await workflowApi.deleteWorkflowNew(workflowId, token);
                toast.success("Workflow deleted successfully");
                fetchWorkflows();
                onRefreshAccounts();
            } catch (error) {
                console.error("Error deleting workflow:", error);
                toast.error("Failed to delete workflow");
            }
    };

    const account = useSelector((state) => state.account.accountDetails);
    const allWorkflowTemplates = useSelector((state) => state.account.allWorkflowTemplates);
    return (
        <div className="space-y-6">
             <WorkflowTasksTabAll
                  allTasks={workflows}
                  errors={errors}
                  onRefreshAccounts={onRefreshAccounts}
                  fetchWorkflows={fetchWorkflows}
                  getStatusColor={getStatusColor}
                  getPriorityColor={getPriorityColor}
                  workflowTemplates={allWorkflowTemplates}
                  accountId ={selectedClientData.id}
                  clients={account}
                  formData={formData}
                  isLoader={isLoader}
                  showCreateTask={showCreateTask}
                  setShowCreateTask={setShowCreateTask}
                  setFormData={setFormData}
                  handleSubmit={handleSubmit}
                  handleDeleteTask={handleDeleteWorkflowNew}
                  workflowId={workflowId}
                  setWorkflowId={setWorkflowId}
                  heading={`${workflows.length} ${workflows.length === 1 ? 'Workflow' : 'Workflows'}`}
                  type={"client"}
              />
              {/* <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <div className="flex items-center justify-between mb-4">
                    <h3 className="text-lg font-semibold text-gray-900">Client Workflows</h3>

                    <Button label="Create Workflow" onClick={() => setShowCreateWorkflow(true)} />
                </div>

                {workflows?.length > 0 ? (
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                        {workflows.map((workflow) => (
                           <div
                      key={workflow.id}
                      className="border border-gray-200 rounded-lg px-4 sm:p-5 bg-white shadow-sm hover:shadow-md transition"
                    >
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-1">
                        <h4 className="font-semibold text-gray-900 text-base sm:text-lg">
                          {workflow.name}
                        </h4>
                        <span
                          className={`w-fit px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(
                            workflow.status
                          )}`}
                        >
                          {workflow.status}
                        </span>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-1 gap-x-4 text-sm">
                        <div className="flex justify-between sm:flex-col">
                          <span className="text-gray-600">Category</span>
                          <span className="font-medium text-gray-900">
                            {workflow.category || "N/A"}
                          </span>
                        </div>

                        <div className="flex justify-between sm:flex-col">
                          <span className="text-gray-600">Template</span>
                          <span className="font-medium text-gray-900">
                            {workflow.template || "N/A"}
                          </span>
                        </div>

                        <div className="flex justify-between sm:flex-col">
                          <span className="text-gray-600">Due Date</span>
                          <span className="font-medium text-gray-900">
                            {workflow.dueDate || "N/A"}
                          </span>
                        </div>

                        <div className="flex justify-between sm:flex-col">
                          <span className="text-gray-600">Tasks</span>
                          <span className="font-medium text-gray-900">
                            {workflow.tasks?.length || 0}
                          </span>
                        </div>
                      </div>

                      {workflow.description && (
                        <div className="mt-2 text-sm">
                          <p className="text-gray-600">Description</p>
                          <p className="text-gray-900">{workflow.description}</p>
                        </div>
                      )}
                    </div>

                        ))}
                    </div>
                ) : (
                    <div className="text-center py-8">
                        <Workflow className="h-12 w-12 text-gray-400 mx-auto mb-4" />
                        <h4 className="text-lg font-medium text-gray-900 mb-2">No Workflows</h4>
                        <p className="text-gray-600 mb-4">No workflows have been created for this client yet.</p>
                        <button onClick={() => setShowCreateWorkflow(true)} className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors">
                            Create First Workflow
                        </button>
                    </div>
                )}
            </div> */}
            {/* {showCreateWorkflow && (
                <CreateWorkflowModal
                    clients={account}
                    accountId ={selectedClientData.id}
                    workflowTemplates={allWorkflowTemplates}
                    setShowCreateWorkflow={setShowCreateWorkflow}
                     onSuccess={fetchWorkflows}
                />
            )} */}
        </div>
    );
};

export default WorkflowsTab;